import { render, staticRenderFns } from "./links-nav-minimal.vue?vue&type=template&id=58e8ee17&"
import script from "./links-nav-minimal.vue?vue&type=script&lang=js&"
export * from "./links-nav-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports